import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../store/store";
import {DropdownItemNames, PartnerDashboardProfilesSortingInfo, ProfileType} from "../models/ProfileResponse";
import {SortType} from "./partnerDashboardConstants";

export type PartnerDashboardProfilesSortingInfoState = {
    partnerDashboardProfilesSortingInfo: PartnerDashboardProfilesSortingInfo,
};

export const initialPartnerDashboardProfilesSortingInfo: PartnerDashboardProfilesSortingInfoState = {
    partnerDashboardProfilesSortingInfo: {
        lanID: "",
        profileType : ProfileType.CLIENT,
        dropdownItemName : DropdownItemNames.ACTIVE_CLIENT,
        profileSortingInfo: [],
        sortColumnName: "profileAlerts",
        lastSortType: SortType.descendingProfileConditions
    }
}

const partnerDashboardProfilesSortingInfoStateSlice = createSlice({
    name: "partnerDashboardProfilesSortingInfo",
    initialState: initialPartnerDashboardProfilesSortingInfo,
    reducers: {
        setPartnerDashboardProfilesSortingInfoState: (state, action: PayloadAction<PartnerDashboardProfilesSortingInfo>) => {
            state.partnerDashboardProfilesSortingInfo = action.payload;
        }
    }
});

export const {
    setPartnerDashboardProfilesSortingInfoState
} = partnerDashboardProfilesSortingInfoStateSlice.actions;

export const selectPartnerDashboardProfilesSortingInfoState = (state: RootState) => state.client.partnerDashboardProfilesSortingInfo.partnerDashboardProfilesSortingInfo;

export default partnerDashboardProfilesSortingInfoStateSlice.reducer;